import React from'react';import{Spinner,SpinnerSize}from'@fluentui/react/lib/Spinner';export default function Loading(props){return React.createElement('div',{className:props.customClass||'center-screen'},React.createElement(Spinner,{style:Object.assign({},props.style),size:SpinnerSize[props.size||'large'],label:!props.hideLabel&&(props.loading||'Loading...')}));}


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading/Loading.js
// module id = 385
// module chunks = 29